// extracted by mini-css-extract-plugin
module.exports = {"flex":"StatusChip_flex__3k1-A","online":"StatusChip_online__35VbT","offline":"StatusChip_offline__2S2oZ","buffer":"StatusChip_buffer__ciOfE"};